import Page from '../pages/Page.vue';
import Search from '../pages/Search.vue';

export default {
    routes: [{
        path: '/search',
        component: Search,
        name: 'search',
        meta: {
            name: 'Search'
        }
    },
    {
        path: '*',
        component: Page,
        name: 'page',
        meta: {
            name: 'Page'
        }
    }]
};